export const DEFAULT_DIMENSION_TABLE_AGGREGATIONS = ['unique_user_id', 'user_conversion_rate'];

export const DEFAULT_FUNNEL_CHART_AGGREGATION = 'user_conversion_rate';

// Special aggregations that are only applicable to full step in funnel analysis dimension tables,
// should be hidden from dimension/metric selection UIs
export const FULL_STEP_SPECIAL_AGGREGATIONS = ['mean_time_since_beginning_ms'];

// Mapping from Step aggregation names to Pattern specific ones
// for full step in funnel analysis dimension tables
export const FULL_STEP_AGGREGATION_REPLACE_MAP: Record<string, string> = {
  mean_time_since_prior_ms: 'mean_time_since_beginning_ms',
};
export const PROPAGATION_FULL_DISPLAY = {
  context: 'Contextual',
  global: 'Global',
};

export const UNIT_OPTIONS = [
  { label: 'Hours', value: 'h' as const },
  { label: 'Minutes', value: 'm' as const },
  { label: 'Seconds', value: 's' as const },
];

export const TIMEOUT_COEFFICIENTS = {
  h: 60 * 60 * 1000,
  m: 60 * 1000,
  s: 1000,
};
